export type FieldErrorProps = { message: string | null | undefined };

/** Error of a field, shown next to it (N59). */
export function FieldError({ message }: FieldErrorProps) {
  if (!message) return null;
  return <p className="mt-1 text-red-600 text-xs">{message}</p>;
}
